import { render, staticRenderFns } from "./Billingcomponent.vue?vue&type=template&id=6c3f36f0&scoped=true&"
import script from "./Billingcomponent.vue?vue&type=script&lang=js&"
export * from "./Billingcomponent.vue?vue&type=script&lang=js&"
import style0 from "./Billingcomponent.vue?vue&type=style&index=0&id=6c3f36f0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3f36f0",
  null
  
)

export default component.exports